import React, { useState } from 'react'
import classnames from 'classnames'
import { ChromePicker } from 'react-color'

import { Item } from '../../../core/items'
import { getItemTranslation } from '../../../core/i18n'
import { LANGUAGE_CODES, SupportedLanguageCode } from '../../../core/i18n'
import { itemInfoTableContent } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'
import ItemRowInput from './item-row/input'

interface Props {
  item: Item
  activeLanguage: SupportedLanguageCode
  onChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void
  onChangeColor: (color: string) => void
}

const ItemInfoForm: React.FC<Props> = props => {
  const { activeLanguage } = props
  const [selectedColor, setSelectedColor] = useState(props.item.color)
  const isEnglishMode = activeLanguage === LANGUAGE_CODES.ENGLISH
  const handleOnChangeColor = (color: any) => {
    setSelectedColor(color.hex)
    props.onChangeColor(color.hex)
  }

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.itemInfoTable}`}>
        <tbody>
          <ItemRowInput
            title={itemInfoTableContent.name}
            value={
              activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.item.name
                : getItemTranslation(
                    props.item.itemTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.name ?? ''
            }
            inputName={
              activeLanguage === LANGUAGE_CODES.JAPANESE
                ? 'name'
                : 'itemTranslations.en_US.name'
            }
            onChange={props.onChange}
          />
          <ItemRowInput
            title={itemInfoTableContent.price}
            value={props.item.price}
            inputName="price"
            onChange={props.onChange}
            disabled={isEnglishMode}
          />
          <ItemRowInput
            title={itemInfoTableContent.priceExcludingTax}
            value={props.item.priceExcludingTax}
            inputName="priceExcludingTax"
            onChange={props.onChange}
            disabled={isEnglishMode}
          />
          <ItemRowInput
            title={itemInfoTableContent.disposalSeconds}
            value={props.item.disposalSeconds}
            inputName="disposalSeconds"
            onChange={props.onChange}
            disabled={isEnglishMode}
          />
          <ItemRowInput
            title={itemInfoTableContent.cupType}
            value={props.item.cupType}
            inputName="cupType"
            onChange={props.onChange}
            disabled={isEnglishMode}
          />
          <tr className={styles.inputRowStatic}>
            <td className={styles.inputCell}>{itemInfoTableContent.color}</td>
            <td className={styles.inputCell}>
              <div
                style={{
                  pointerEvents: isEnglishMode ? 'none' : 'auto',
                  opacity: isEnglishMode ? 0.5 : 1,
                }}
              >
                <ChromePicker
                  color={selectedColor}
                  onChange={handleOnChangeColor}
                  disableAlpha={true}
                />
              </div>
            </td>
          </tr>
          <ItemRowInput
            title={itemInfoTableContent.description}
            value={
              activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.item.description
                : getItemTranslation(
                    props.item.itemTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.description ?? ''
            }
            inputName={
              activeLanguage === LANGUAGE_CODES.JAPANESE
                ? 'description'
                : 'itemTranslations.en_US.description'
            }
            onChange={props.onChange}
          />
          <ItemRowInput
            title={itemInfoTableContent.story}
            value={
              activeLanguage === LANGUAGE_CODES.JAPANESE
                ? props.item.story
                : getItemTranslation(
                    props.item.itemTranslations,
                    LANGUAGE_CODES.ENGLISH
                  )?.story ?? ''
            }
            inputName={
              activeLanguage === LANGUAGE_CODES.JAPANESE
                ? 'story'
                : 'itemTranslations.en_US.story'
            }
            inputType="textarea"
            onChange={props.onChange}
          />
        </tbody>
      </table>
    </div>
  )
}

export default ItemInfoForm
